<template>
  <span class="snav-act">
    <a v-if="username" class="profile-button" :href="'?player=' + encodeURIComponent(username)" aria-label="My profile">👤</a>
    <button v-else class="login-button" @click="login" aria-label="Log in with Twitch">Log in</button>
    <span class="act-tip">
      <template v-if="username">Your full player profile — stats, achievements, championship history.</template>
      <template v-else>Log in with Twitch: one click sets your username, so the site highlights your units and links your profile. It only learns your name.</template>
    </span>
  </span>
</template>

<script>
import { startTwitchLogin } from '../lib/twitchAuth.js';

// The nav bar's "you" slot: your 👤 profile button once the site knows your username
// (typed in Settings or from Twitch), else a one-click "Log in" with Twitch. Styled by
// Luxstadio's global .snav-act rules, like its neighbours.
export default {
  name: 'NavLogin',
  props: { username: { type: String, default: '' } },
  methods: { login() { startTwitchLogin(); } },
};
</script>
